<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Contact-Worldwide Offices List',
          to: { name: 'ContactPage' } },
        {
          name: 'Edit Contact-Worldwide Offices Title',
          to: { name: 'EditContactPagePageTitle' },
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Contact-Worldwide Offices Title</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>

    <!-- block -->
    <div class="block" v-if="pageTitle != null">
      <!-- PageTitle -->
      <div class="form-item pt-5 d-flex">
        <div class="w-240px mr-5">
          <h4>PageTitle</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="pageTitle.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Description -->
      <div class="form-item pt-5 d-flex">
        <div class="w-240px mr-5">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <editor
            v-model="pageTitle.description"
            :plugins="'link'"
            :toolbar="'link'"
          />
        </div>
      </div>
      <!-- Background -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-3">Desktop Image</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：1920px*300px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <ImgUploader
            :imageUrl.sync="pageTitle.image"
            dir="pageTitle"></ImgUploader>
        </div>
      </div>
      <!-- Background -->
      <div class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-3">Mobile Image</h4>
          <div class="h5 ink-02-medium--text">
            建議尺寸：1920px*300px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <ImgUploader
            :imageUrl.sync="pageTitle.image_mobile"
            dir="pageTitle"></ImgUploader>
        </div>
      </div>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    Breadscrumbs,
    ImgUploader,
    LangDialog,
    Editor,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('pageTitle', ['pageTitle']),
  },
  created() {
    if (this.pageTitle === null) {
      this.getPageTitle('contact');
    }
  },
  methods: {
    ...mapActions('pageTitle', {
      savePageTitle: 'save',
      getPageTitle: 'findByType',
    }),
    cancelHandler() {
      this.$router.push({ name: 'ContactPage' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.pageTitle.type = 'contact';
        this.savePageTitle(this.pageTitle).then(() => {
          this.$router.push({ name: 'ContactPage' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
